module.exports = __webpack_public_path__ + "img/LVA.f715337d.svg";